import { select, put, call, takeLatest } from "redux-saga/effects";
import { LOAD_OPEN_INCIDENT, LOAD_CLOSE_INCIDENT, ADD_RESOLUTION_PROPOSAL_ACTION, ADD_COMMENT } from "./incidentActionTypes";
import { loadOpenIncidentSuccess, loadOpenIncidentFailed, loadCloseIncidentSuccess, loadCloseIncidentFailed, addResolutionProposalActionFailed, addResolutionProposalActionSuccess, addCommentSuccess, addCommentFailed } from "./incidentActions";
import ServiceApi from "../api/ServiceApi";

export const getOidc = state => state.oidc;

function* loadOpenIncident() {
  try {
    let oidc = yield select(getOidc);
    const response = yield call(ServiceApi.getOpenIncidents, oidc.user);
    yield put(loadOpenIncidentSuccess(response));
  } catch (e) {
    yield put(loadOpenIncidentFailed(e.message));
  }
}

export function* loadOpenIncidentSaga() {
  yield takeLatest(LOAD_OPEN_INCIDENT, loadOpenIncident);
}

function* loadCloseIncident() {
  try {
    let oidc = yield select(getOidc);
    const response = yield call(ServiceApi.getCloseIncidents, oidc.user);
    yield put(loadCloseIncidentSuccess(response));
  } catch (e) {
    yield put(loadCloseIncidentFailed(e.message));
  }
}

export function* loadCloseIncidentSaga() {
  yield takeLatest(LOAD_CLOSE_INCIDENT, loadCloseIncident);
}

function* addResolutionProposalAction(action) {
  try {
    let oidc = yield select(getOidc);
    yield call(ServiceApi.putResolutionProposal, oidc.user, action.payload.incidentId, action.payload.commentId, action.payload.action);
    yield put(addResolutionProposalActionSuccess(action.payload));
  } catch (e) {
    yield put(addResolutionProposalActionFailed(e.message));
  }
}

export function* addResolutionProposalActionSaga() {
  yield takeLatest(ADD_RESOLUTION_PROPOSAL_ACTION, addResolutionProposalAction);
}

function* addComment(action) {
  try {
    let oidc = yield select(getOidc);
    yield call(ServiceApi.postComment, oidc.user, action.payload.incidentId, action.payload.comment, action.payload.commentType);
    yield put(addCommentSuccess(action.payload));
  } catch (e) {
    yield put(addCommentFailed(e.message));
  }
}

export function* addCommentSaga() {
  yield takeLatest(ADD_COMMENT, addComment);
}



// WEBPACK FOOTER //
// ./src/incidents/incidentSagas.js